export default __webpack_public_path__ + "static/media/witcher.920f5f1c.jpg";